import { TemplateRef } from '@angular/core';
import { UserService } from '../../services/user.service';
import { MatDialog, MatSnackBar, MatPaginator, MatSort } from '@angular/material';
import { PerfilComponent } from './../perfil/perfil.component';
import { FormBuilder } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { MatTableDataSource } from '@angular/material';
import { Seguimiento_exp_Service } from 'src/app/services/seguimiento_exp.service';
import { GLOBAL } from 'src/app/services/global';
var Seguimiento_expedienteComponent = /** @class */ (function () {
    function Seguimiento_expedienteComponent(_route, _router, _formBuilder, _userService, spinner, dialog, _formService, _expService, snackBar) {
        this._route = _route;
        this._router = _router;
        this._formBuilder = _formBuilder;
        this._userService = _userService;
        this.spinner = spinner;
        this.dialog = dialog;
        this._formService = _formService;
        this._expService = _expService;
        this.snackBar = snackBar;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.web = GLOBAL.web;
        this.footer = GLOBAL.footer;
        this.displayedColumns = ['solicitud', 'expediente', 'fecha_solicitud', 'departamento', 'estado', 'detalle'];
        this.dataSource = new MatTableDataSource();
        this.temp_dir = "a";
        this.isopen = false;
        this.matcher = new FormService();
        //public licitaciones = [];
        this.rows = [];
        this.seguim_exped = [];
        this.p = 1;
        // displayedColumns: string[] = ['select', 'rut', 'departamento'];
        //dataSource = new MatTableDataSource<PeriodicElement>(this.seguim_exped);
        this.urb = false;
        this.edif = false;
        this.recep = false;
        this.arquitecto = false;
        this.rechazada = false;
        this.estatus = false;
        this.estatus_aprob = false;
        this.fechaacta = false;
        this.seguim_exp = { num_solicitud: '', expediente: '', tipo: '', rol_propiedad: '', direccion: '', direccion_edif: '', fecha_ingreso: null, estado: '', descripcion: '', nombre_arquitecto: '', fono_arquitecto: '', email_arquitecto: '', fecha_acta: null, plazo_maximo: '', fecha_notificacion: null, fecha_ingreso_acta: null, numero_oficio: '', fecha_oficio: null, fecha_aprobacion_dom: null, fecha_aprobacion: null, numero_aprobacion: '', fecha_visita_terreno: null, vivienda_altura: '', estado_calculo_derechos: '', recordId: '' };
        // this.solicitante = { rut: '', departamento: '', numero: '' }
        console.log("Seguimiento_expedienteComponent");
        this.informacion = JSON.parse(sessionStorage.getItem("identity-domCloud"));
        this.rut_solic = this.informacion.rut + "-" + this.informacion.dv;
        this.rut = this.rut_solic;
        if (!JSON.parse(localStorage.getItem("solicitud_exp"))) {
            localStorage.setItem("solicitud_exp", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("solicitud_exp"));
        }
        this.get_solicitudes(this.rut);
        registerLocaleData(es);
    }
    Seguimiento_expedienteComponent.prototype.pad_with_zeroes = function (number, length) {
        var my_string = '' + number;
        while (my_string.length < length) {
            my_string = '0' + my_string;
        }
        return my_string;
    };
    Seguimiento_expedienteComponent.prototype.getCleanedString = function (cadena) {
        // Definimos los caracteres que queremos eliminar
        var specialChars = "!@#$^&%*()+=-[]\/{}|:<>?,.";
        // Los eliminamos todos
        for (var i = 0; i < specialChars.length; i++) {
            cadena = cadena.replace(new RegExp("\\" + specialChars[i], 'gi'), '');
        }
        // Lo queremos devolver limpio en mayuscula
        cadena = cadena.toLowerCase();
        // Quitamos espacios y los sustituimos por _ porque nos gusta mas asi
        // cadena = cadena.replace(/ /g,"_");
        // Quitamos acentos y "ñ". Fijate en que va sin comillas el primer parametro
        cadena = cadena.replace(/á/gi, "a");
        cadena = cadena.replace(/é/gi, "e");
        cadena = cadena.replace(/í/gi, "i");
        cadena = cadena.replace(/ó/gi, "o");
        cadena = cadena.replace(/ú/gi, "u");
        cadena = cadena.replace(/ñ/gi, "n");
        cadena = cadena.toUpperCase();
        return cadena;
    };
    Seguimiento_expedienteComponent.prototype.ngOnInit = function () {
        //this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    };
    Seguimiento_expedienteComponent.prototype.ngAfterViewInit = function () {
        this.dataSource.sort = this.sort;
    };
    Seguimiento_expedienteComponent.prototype.get_solicitudes = function (rut) {
        var _this = this;
        this.spinner.show();
        this._expService.getSolicitudes(rut).subscribe(function (response) {
            if (response.message) {
                _this.dialog.open(_this.openModal);
                //alert("El Rut que estas buscando no existe en los registros");
                _this.spinner.hide();
            }
            else {
                _this.solicitudes = response.solicitudes;
                _this.dataSource = _this.solicitudes;
                _this.spinner.hide();
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    Seguimiento_expedienteComponent.prototype.get_solicitud = function (sol) {
        var _this = this;
        this.spinner.show();
        var departamento = sol.departamento;
        if ((departamento == 'URB') || (departamento == 'RECEP')) {
            var numero = sol.solicitud;
        }
        else if (departamento == 'EDIF') {
            var numero = sol.expediente;
        }
        this._expService.getExp(this.rut_solic, numero, departamento).subscribe(function (response) {
            if (response.message) {
                alert("El Rut que estas buscando no existe en los registros");
                _this.spinner.hide();
            }
            else {
                if (departamento == 'EDIF') {
                    _this.edif = true;
                    _this.urb = false;
                    _this.recep = false;
                }
                else if (departamento == 'URB') {
                    _this.edif = false;
                    _this.urb = true;
                    _this.recep = false;
                }
                else if (departamento == 'RECEP') {
                    _this.recep = true;
                    _this.urb = false;
                    _this.edif = false;
                }
                _this.seguim_exp.num_solicitud = response.num_solicitud ? response.num_solicitud : '';
                _this.seguim_exp.expediente = response.expediente ? response.expediente : '';
                localStorage.setItem("solicitud_exp", JSON.stringify([]));
                _this.actualRow = localStorage.getItem("solicitud_exp");
                _this.rows = JSON.parse(_this.actualRow);
                _this.rows = _this.rows.concat({
                    solicitud: _this.seguim_exp.num_solicitud
                });
                localStorage.setItem("solicitud_exp", JSON.stringify(_this.rows));
                _this.seguim_exp.tipo = response.tipo ? response.tipo : '';
                _this.seguim_exp.rol_propiedad = response.rol_propiedad ? response.rol_propiedad : '';
                _this.seguim_exp.direccion = response.direccion ? response.direccion : '';
                _this.seguim_exp.direccion_edif = response.direccion_edif ? response.direccion_edif : '';
                _this.seguim_exp.fecha_ingreso = response.fecha_ingreso ? response.fecha_ingreso : '';
                _this.seguim_exp.estado = response.estado ? response.estado : '';
                if ((departamento == 'URB') || (departamento == 'RECEP')) {
                    if ((_this.seguim_exp.estado == '0') || (_this.seguim_exp.estado == '1') || (_this.seguim_exp.estado == '2') || (_this.seguim_exp.estado == '5') || (_this.seguim_exp.estado == '8') || (_this.seguim_exp.estado == '9')) {
                        _this.seguim_exp.descripcion = response.descripcion ? response.descripcion : '';
                    }
                    else {
                        _this.seguim_exp.descripcion = 'EN PROCESO';
                    }
                }
                else if (departamento == 'EDIF') {
                    if ((_this.seguim_exp.estado == '7') || (_this.seguim_exp.estado == '8')) {
                        _this.seguim_exp.descripcion = 'APROBADO';
                    }
                    else if ((_this.seguim_exp.estado == '0') || (_this.seguim_exp.estado == '1') || (_this.seguim_exp.estado == '2') || (_this.seguim_exp.estado == '5')) {
                        _this.seguim_exp.descripcion = response.descripcion ? response.descripcion : '';
                    }
                    else if (_this.seguim_exp.estado == '9') {
                        _this.seguim_exp.descripcion = 'RECHAZADO';
                    }
                    else {
                        _this.seguim_exp.descripcion = 'EN PROCESO';
                    }
                }
                _this.seguim_exp.nombre_arquitecto = response.nombre_arquitecto ? response.nombre_arquitecto : '';
                if (!(_this.seguim_exp.nombre_arquitecto)) {
                    _this.arquitecto = false;
                    _this.arquit = "#7d7d7d";
                    _this.colorarquit = "black";
                }
                else {
                    _this.arquitecto = true;
                    _this.arquit = "#009abb";
                    _this.colorarquit = "oldlace";
                }
                _this.seguim_exp.fono_arquitecto = response.fono_arquitecto ? response.fono_arquitecto : '';
                _this.seguim_exp.email_arquitecto = response.email_arquitecto ? response.email_arquitecto : '';
                _this.seguim_exp.fecha_acta = response.fecha_acta ? response.fecha_acta : null;
                if (!(_this.seguim_exp.fecha_acta) || (_this.seguim_exp.fecha_acta == null)) {
                    _this.fechaacta = false;
                    _this.obser = "#7d7d7d";
                    _this.colorobserv = "black";
                }
                else {
                    _this.fechaacta = true;
                    _this.obser = "#009abb";
                    _this.colorobserv = "oldlace";
                }
                _this.seguim_exp.plazo_maximo = response.plazo_maximo ? response.plazo_maximo : '';
                _this.seguim_exp.fecha_notificacion = response.fecha_notificacion ? response.fecha_notificacion : '';
                _this.seguim_exp.fecha_ingreso_acta = response.fecha_ingreso_acta ? response.fecha_ingreso_acta : '';
                _this.seguim_exp.numero_oficio = response.numero_oficio ? response.numero_oficio : '';
                _this.seguim_exp.fecha_oficio = response.fecha_oficio ? response.fecha_oficio : '';
                _this.seguim_exp.fecha_aprobacion_dom = response.fecha_aprobacion_dom ? response.fecha_aprobacion_dom : '';
                if (!(_this.seguim_exp.numero_oficio) || (_this.seguim_exp.estado == '9')) {
                    _this.rechazada = true;
                    _this.titulo = 'RECHAZADA';
                    _this.letracolor = "oldlace";
                    _this.estadocolor = '#009abb';
                }
                else if (_this.seguim_exp.estado == '0') {
                    _this.estatus = false;
                    _this.titulo = 'ANULADA';
                    _this.letracolor = "black";
                    _this.estadocolor = '#7d7d7d';
                }
                else if ((!(_this.seguim_exp.fecha_aprobacion_dom)) && (!(_this.seguim_exp.estado == '0'))) {
                    _this.estatus = true;
                    _this.titulo = 'EN PROCESO';
                    _this.letracolor = "oldlace";
                    _this.estadocolor = '#009abb';
                }
                else if (_this.seguim_exp.estado == '8') {
                    _this.estatus_aprob = true;
                    _this.titulo = 'APROBADA';
                    _this.letracolor = "oldlace";
                    _this.estadocolor = '#009abb';
                }
                _this.seguim_exp.fecha_aprobacion = response.fecha_aprobacion ? response.fecha_aprobacion : '';
                _this.seguim_exp.numero_aprobacion = response.numero_aprobacion ? response.numero_aprobacion : 0;
                _this.seguim_exp.fecha_visita_terreno = response.fecha_visita_terreno ? response.fecha_visita_terreno : '';
                if (departamento == 'RECEP') {
                    if (!(_this.seguim_exp.fecha_visita_terreno)) {
                        _this.fechavisita = false;
                        _this.fechacolor = "black";
                        _this.estadofecha = '#7d7d7d';
                    }
                    else {
                        _this.fechavisita = true;
                        _this.fechacolor = "oldlace";
                        _this.estadofecha = '#009abb';
                    }
                }
                _this.seguim_exp.vivienda_altura = response.vivienda_altura ? response.vivienda_altura : '';
                _this.seguim_exp.estado_calculo_derechos = response.estado_calculo_derechos ? response.estado_calculo_derechos : '';
                _this.seguim_exp.vivienda_altura = response.vivienda_altura ? response.vivienda_altura : '';
                _this.seguim_exp.estado_calculo_derechos = response.estado_calculo_derechos ? response.estado_calculo_derechos : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModalExp);
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    Seguimiento_expedienteComponent.prototype.getActa = function (exp) {
        var _this = this;
        this.spinner.show();
        this._expService.getActa(exp).subscribe(function (response) {
            if (response.message) {
                _this.cleanData();
                alert("El número de solicitud que estas buscando no existe en los registros");
                _this.spinner.hide();
            }
            else {
                _this.acta.id_solicitud = response.id_solicitud ? response.id_solicitud : '';
                _this.acta.fecha_acta = response.fecha_acta ? response.fecha_acta : '';
                _this.acta.encabezado = response.encabezado ? response.encabezado : '';
                _this.acta.notas = response.notas ? response.notas : '';
                _this.acta.notas1 = response.notas1 ? response.notas1 : '';
                _this.spinner.hide();
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    Seguimiento_expedienteComponent.prototype.ngDoCheck = function () {
        // this.lSolicitud = this.firstFormGroup.get('departamento').value;
    };
    Seguimiento_expedienteComponent.prototype.cleanData = function () {
        this.seguim_exp = { num_solicitud: '', expediente: '', tipo: '', rol_propiedad: '', direccion: '', direccion_edif: '', fecha_ingreso: null, estado: '', descripcion: '', nombre_arquitecto: '', fono_arquitecto: '', email_arquitecto: '', fecha_acta: null, plazo_maximo: '', fecha_notificacion: null, fecha_ingreso_acta: null, numero_oficio: '', fecha_oficio: null, fecha_aprobacion_dom: null, fecha_aprobacion: null, numero_aprobacion: '', fecha_visita_terreno: null, vivienda_altura: '', estado_calculo_derechos: '', recordId: '' };
    };
    Seguimiento_expedienteComponent.prototype.inicio = function () {
        this._router.navigate(['/']);
    };
    Seguimiento_expedienteComponent.prototype.perfil = function () {
        this.dialog.open(PerfilComponent);
    };
    Seguimiento_expedienteComponent.prototype.logout = function () {
        sessionStorage.removeItem("identity-domCloud");
        sessionStorage.removeItem("token-domCloud");
        this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
            duration: 3000,
        });
        this._router.navigate(['/']);
    };
    return Seguimiento_expedienteComponent;
}());
export { Seguimiento_expedienteComponent };
